import {colors, media, text} from '../styles'
import {css} from 'glamor'
import LegacySearchBar from './legacy/searchBar'
import PropTypes from 'prop-types'
import React from 'react'

const style = {
  searchBar: css({
    position: 'relative',
    fontWeight: '400',
    '> div > input': css(text.body, {
      borderRadius: '32px',
      boxShadow: '0 0 4px rgba(0, 0, 0, 0.15)',
      margin: 0,
      padding: '12px 64px 12px 22px',
      width: '100%',
      '&:focus': {
        boxShadow: '0 0 4px rgba(0, 0, 0, 0.4)',
        outline: 'none'
      }
    }),
    '> div > .icon': css({
      background: colors.primaryBG,
      borderBottomRightRadius: '20px',
      borderTopRightRadius: '20px',
      color: colors.white,
      margin: 0,
      padding: '12px 17px 12px 12px',
      position: 'absolute',
      right: '2px',
      top: '2px',
      ...media.xs({
        padding: '9px 17px 10px 12px',
        right: '1px',
        top: '1px'
      }),
      ...media.sm({
        padding: '10px 17px 10px 12px',
        right: '1px',
        top: '1px'
      })
    }),
    '> div > .search-pane': {
      left: 0,
      right: 'auto',
      top: '42px',
      width: '100%',
      '& .search-name': css(text.body, {
        margin: '0 0 4px'
      }),
      '& .search-page > li': {
        border: `1px solid ${colors.gray89}`,
        borderLeft: 'none',
        display: 'none',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '38px',
        margin: '16px 0',
        padding: 0,
        width: '40px',
        '&:first-child': {
          borderLeft: `1px solid ${colors.gray89}`
        },
        '& > a': {
          display: 'block'
        }
      }
    },
    ...media.mobile({
      boxShadow: 'none',
      display: 'inline-block',
      margin: '12px 0 0',
      textAlign: 'left',
      width: '100%'
    })
  })
}

const SearchBar = ({location, name, placeholder}) => (
  <div {...style.searchBar}>
    <LegacySearchBar
      location={location}
      name={name}
      placeholder={placeholder}
    />
  </div>
)

SearchBar.propTypes = {
  location: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired
}

export default SearchBar
